import { render, staticRenderFns } from "./AddAnnouncementDialog.vue?vue&type=template&id=15b0dee3&scoped=true&lang=pug"
import script from "./AddAnnouncementDialog.vue?vue&type=script&lang=js"
export * from "./AddAnnouncementDialog.vue?vue&type=script&lang=js"
import style0 from "./AddAnnouncementDialog.vue?vue&type=style&index=0&id=15b0dee3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b0dee3",
  null
  
)

export default component.exports